import { useRef, useEffect } from 'react';

// This custom hook, useInterval, allows you to easily set up and manage intervals in your React components.
// It encapsulates the logic for creating, maintaining, and clearing intervals, making it simpler to execute repeating actions over time.
// The hook takes a callback function and a delay (in milliseconds) as arguments.
// The interval automatically starts when the component mounts and is cleared when the component unmounts or the delay changes.
function useInterval(callback, delay) {
    const savedCallback = useRef();
    // Remember the latest callback.
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);
    // Set up the interval.
    useEffect(() => {
        function tick() {
            if (savedCallback.current) {
                savedCallback.current();
            }
        }
        let id = null;
        if (delay !== null) {
            id = setInterval(tick, delay);
        }
        return () => {
            if (id) {
                clearInterval(id);
            }
        };
    }, [delay]);
}

export { useInterval as default };
//# sourceMappingURL=useInterval.js.map
